import { render, staticRenderFns } from "./AydemPopup.vue?vue&type=template&id=966a6f06&scoped=true&"
import script from "./AydemPopup.vue?vue&type=script&lang=js&"
export * from "./AydemPopup.vue?vue&type=script&lang=js&"
import style0 from "./AydemPopup.vue?vue&type=style&index=0&id=966a6f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966a6f06",
  null
  
)

export default component.exports